import React from 'react';
import { Box, Select, MenuItem, Typography } from '@mui/material';

interface Props {
  label: string;
  description?: string;
  value: string;
  onChange: (v: string) => void;
  options: { label: string; value: string }[];
}

const SelectField: React.FC<Props> = ({ label, description, value, onChange, options }) => (
  <Box>
    <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#141417', mb: 0.5, fontFamily: 'Manrope, sans-serif' }}>{label}</Typography>
    {description && <Typography sx={{ fontSize: 11, color: '#6F6F6F', mb: 0.5 }}>{description}</Typography>}
    <Select
      fullWidth
      size="small"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      sx={{ fontSize: 13, borderRadius: '6px', maxWidth: 300 }}
    >
      {options.map((o) => (
        <MenuItem key={o.value} value={o.value} sx={{ fontSize: 13 }}>{o.label}</MenuItem>
      ))}
    </Select>
  </Box>
);

export default SelectField;
